import React from 'react';

export default function Bio() {
  return (
    <section id="about" className="py-20 md:py-28" style={{backgroundColor: '#7B96B5'}}>
      <div className="max-w-3xl mx-auto px-5 md:px-10 flex flex-col items-center">
        <p className="font-anton uppercase tracking-[0.3em] text-cream text-xs mb-4 self-start">— Listen</p>
        <iframe
          title="Mariah Angeliq on Spotify"
          src="https://open.spotify.com/embed/artist/0KKUc4amZyvswV2YL6WTar?theme=0"
          width="100%"
          height="352"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          style={{ borderRadius: 12, display: 'block' }}
        />
        <iframe
          title="Mariah Angeliq on Apple Music"
          src="https://embed.music.apple.com/us/artist/mariah-angeliq/1405167443"
          width="100%"
          height="450"
          frameBorder="0"
          allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
          sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
          loading="lazy"
          style={{ borderRadius: 12, display: 'block', marginTop: 16, background: 'transparent' }}
        />
      </div>
    </section>
  );
}
